import cx from "classnames";
import { IconArrowUp } from "@/shared/ui/Icons";
import Button from "@/shared/ui/Button";

type ExpandCellProps = {
  cell: any,
  [x:string]: any,
}

const ExpandCell = (props: ExpandCellProps) => {
  const { row, cell } = props;
  const isExpandedCell = cell?.row?.isExpanded;
  return (<div className="flex justify-center w-full">
    <Button colorSchema="plain" size="xs" onClick={row.original?.onClick}>
      <IconArrowUp className={cx("transition-all rotate-180", {"rotate-0": isExpandedCell})}/>
    </Button>
  </div>)
}

export default ExpandCell;